import { Copy } from '@phosphor-icons/react';
import { toast } from 'react-toastify';
import { ToastWithCustomIcon } from 'src/components/Toast';

const SVG_SIZE = 24;

type CopyButtonProps = {
  text: string;
};

export const CopyButton = ({ text }: CopyButtonProps) => {
  const handleCopyClick = () => {
    navigator.clipboard.writeText(text);

    toast(<ToastWithCustomIcon message="Copied" />);
  };

  return (
    <button
      type="button"
      className="nj-modal-gallery-activity-button"
      onClick={(e) => {
        e.stopPropagation();
        handleCopyClick();
      }}
    >
      <Copy size={SVG_SIZE} />
    </button>
  );
};
